/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
import "crp_meta_ui/elements/disclaimer-component.js";
const template = html`
    <style include="app-styles">
      paper-card {
        height: fit-content !important;
        padding:24px 10% 10%;
      }
      paper-checkbox .selection-checkbox {
        --paper-checkbox-label-spacing: 0;
        --paper-checkbox-checked-color: #3CB371;
      }
      .list-search{
        padding: 0 0px 20px 0px;
      }
      .listing-filter-actions {
        padding: 0px 24px 24px;
      }
      .font-style {
        letter-spacing: 0.0025em;
      }
      .heading-sub-font {
        padding: 0px 24px 24px;
      }
      .font-color{
        color: rgb(0, 131, 155);
      }
    </style>
    <oe-ajax id="fetchOpenBankingDebitAccounts" url="api/transactionDebitAccounts/transactionDebitAccounts?filter[where][transactionType]=SLF" on-response="_openBankingDebitConsentResponse" on-error="_openBankingDebitConsentError"></oe-ajax>
    <oe-ajax id="fetchOpenBankingConsents" url="/api/CBUsers/{{userId}}/customopenbanking-consent-request?filter[where][consentId]={{consentId}}" on-response="_openBankingConsentsResponse" on-error="_openBankingConsentsResponseError"></oe-ajax>
    <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}" notsupporteddevice={{notsupporteddevice}}></app-media-query>
    <page-title name="h_CorporateDashboard" left-action="{{leftAction}}"></page-title>
    <div class="content-align-center">
      <div class="margin-b-zero mdl-cell mdl-cell--10-col">
        <paper-card>
          <h1 class="credit-heading">
            <disclaimer-component info-msg = {{infoMsgVatAmount}}></disclaimer-component>
          </h1>
          <h1 class="credit-heading">
            <disclaimer-component info-msg = {{infoMsgExchangeRate}}></disclaimer-component>
          </h1>
          <div class="mdl-grid mdl-grid--no-spacing" style="margin: 24px 24px;">
            <div class="mdl-cell mdl-cell--12-col" style="padding-bottom: 10px"> 
                <div class="font-style font-30">
                    <oe-i18n-msg msgid="h_paymentConsent" role="heading" aria-level="1"></oe-i18n-msg>
                </div>
            </div>
          </div>
          <div class="listing-table-container margin-b-16" style="border:2px solid #f6f8f9;border-radius: 5px;">
              <div class="mdl-cell mdl-cell--10-col margin-32">
                <h1 class="pay_from ft-subtitle"><oe-i18n-msg msgid="l_PayFrom"></oe-i18n-msg></h1>                  
                <account-selector min-width="20px" class="custom-combo" id="debitAccountSelector" show-template label="l_debitAccount" required
                    on-change="_debitAccountSelected" listdata="{{openBankingDebitAccountsResponse}}" value="{{selectedDebitAccount}}" dataurl={{debitAccountsUrl}} 
                    displayproperty="accountNickname" searchable selected-value="{{_populateInitialValue()}}" mapping-keys={{debitAccountFields}}
                    show-balance balance-resp="{{balanceResp}}" disabled=[[debitAccountDisabled]]>
                  <template item-template>
                    <paper-item on-mouseover="onMouseOver" on-tap="onItemSelected" data-item="{{item}}"  disabled="[[readonly]]">
                      <div style="width: 100%; display: inline-flex; padding: 5px 0 5px 20px;">
                        <div style="width: 80%; display: inline-grid;">
                          <strong id="acName" style="font-size: 14px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{item.accountNickname}}</strong>
                          <span id="acName"
                            style="font-size: 12px; color: #636c75; margin-top: -10px;">{{item.accountId}}
                          </span>
                        </div>
                        <div style="width: 20%; text-align: end; display: inline-grid;">
                          <paper-item
                            style="display: inline-flex;align-items: center;justify-content: flex-end;">
                            <img id="acName" style="width: 16px;height: 16px;padding-right: 10px;"
                              src="../../../images/country_flags/[[item.accountCurrency.codeDescription]].png" />
                            <span
                              style="font-size: 14px;">[[item.accountCurrency.codeDescription]]</span>
                          </paper-item>
                        </div>
                      </div>
                    </paper-item>
                  </template>
                </account-selector>
              </div>
          </div>
          <template is="dom-if" if="{{accountsListLoaded}}">
            <template is="dom-if" if="[[openBankingConsentResponse]]">
              <div class="listing-table-container margin-b-16" style="border:2px solid #f6f8f9;border-radius: 5px;">
                  <div class="mdl-cell mdl-cell--12-col margin-32">
                    <h1 class="pay_from ft-subtitle padding-b-32"><oe-i18n-msg msgid="h_beneficieryDeatilsSmall"></oe-i18n-msg></h1>                  
                    <div class="mdl-cell mdl-cell--12-col horizontal layout layoutdiv margin-l-zero" style="flex-wrap: wrap">
                      <template is="dom-if" if="{{openBankingConsentResponse.paymentConsent.reference}}">
                        <div class="mdl-cell mdl-cell--6-col padding-b-16">
                            <span class="secondary-dark-text-s">
                                <oe-i18n-msg msgid="l_ReferenceId"></oe-i18n-msg>
                            </span>
                            <div class="primary-dark-text-m font-medium wordbreak-all">
                            {{openBankingConsentResponse.paymentConsent.reference}}
                            </div>
                        </div>
                      </template>
                      <template is="dom-if" if="{{openBankingConsentResponse.paymentConsent.paymentType.codeDescription}}">
                        <div class="mdl-cell mdl-cell--6-col padding-b-16">
                            <span class="secondary-dark-text-s">
                                <oe-i18n-msg msgid="l_TransferType"></oe-i18n-msg>
                            </span>
                            <div class="primary-dark-text-m font-medium wordbreak-all">
                            {{openBankingConsentResponse.paymentConsent.paymentType.codeDescription}}
                            </div>
                        </div>
                      </template>
                      <div class="mdl-cell mdl-cell--6-col padding-b-16">
                          <span class="title-text">
                              <oe-i18n-msg msgid="l_Benefname"></oe-i18n-msg>
                          </span>
                          <div class="primary-dark-text-m font-medium wordbreak-all">
                              {{openBankingConsentResponse.paymentConsent.name}}
                          </div>
                      </div>
                      <template is="dom-if" if="{{openBankingConsentResponse.paymentConsent.creditorAccountId}}">
                          <div class="mdl-cell mdl-cell--6-col padding-b-16">
                              <span class="secondary-dark-text-s">
                                  <oe-i18n-msg msgid="l_BeneficiaryAcct"></oe-i18n-msg>
                              </span>
                              <div class="primary-dark-text-m font-medium wordbreak-all">
                                  {{openBankingConsentResponse.paymentConsent.creditorAccountId}}
                              </div>
                          </div>
                      </template>
                      <template is="dom-if" if="{{openBankingConsentResponse.paymentConsent.instructedAmount.amount}}">
                        <div class="mdl-cell mdl-cell--6-col padding-b-16">
                            <span class="secondary-dark-text-s">
                                <oe-i18n-msg msgid="l_TransferAmt"></oe-i18n-msg>
                            </span>
                            <div class="primary-dark-text-m font-medium wordbreak-all">
                            {{openBankingConsentResponse.paymentConsent.instructedAmount.currency}} {{openBankingConsentResponse.paymentConsent.instructedAmount.amount}}
                            </div>
                        </div>
                      </template>
                      <template is="dom-if" if="{{openBankingConsentResponse.paymentConsent.swiftCode}}">
                        <div class="mdl-cell mdl-cell--6-col padding-b-16">
                            <span class="secondary-dark-text-s">
                                <oe-i18n-msg msgid="l_swiftCode"></oe-i18n-msg>
                            </span>
                            <div class="primary-dark-text-m font-medium wordbreak-all">
                            {{openBankingConsentResponse.paymentConsent.swiftCode}}
                            </div>
                        </div>
                      </template>
                      <template is="dom-if" if="{{openBankingConsentResponse.paymentConsent.purposeCode}}">
                        <div class="mdl-cell mdl-cell--6-col padding-b-16">
                            <span class="secondary-dark-text-s">
                                <oe-i18n-msg msgid="l_purposeCode"></oe-i18n-msg>
                            </span>
                            <div class="primary-dark-text-m font-medium wordbreak-all">
                            {{openBankingConsentResponse.paymentConsent.purposeCode.codeDescription}}
                            </div>
                        </div>
                      </template>
                      <template is="dom-if" if="{{openBankingConsentResponse.executionDate}}">
                        <div class="mdl-cell mdl-cell--6-col padding-b-16">
                            <span class="secondary-dark-text-s">
                                <oe-i18n-msg msgid="l_executionDate"></oe-i18n-msg>
                            </span>
                            <div class="primary-dark-text-m font-medium wordbreak-all">
                            {{formatDate(openBankingConsentResponse.executionDate)}}
                            </div>
                        </div>
                      </template>
                    </div>
                  </div>
              </div>
            </template>
            <template is="dom-if" if="[[!openBankingConsentResponse]]">
                <div class="mdl-grid mdl-cell light-background full-width content-align-center margin-zero">
                    <supporting-msg icon-name="no_txn" background="" title-msg="m_genericError"></supporting-msg>
                </div>
            </template>
          </template>
          <template is="dom-if" if="{{!accountsListLoaded}}">
            <paper-card class="full-width" elevation="0">
                <div class="content-align-center light-background spinner-innder-div text-align-center">
                    <paper-spinner active></paper-spinner>
                </div>
            </paper-card>
          </template>
          <div class="mdl-cell--12-col horizontal layout content-align-horizontal-end" tabindex="0" style="padding:2% 0px 10;">
            <div class="mdl-cell--2-col" style="width: auto; margin-right: 16px;"> 
              <paper-button raised class="secondary-medium-button" on-tap="_proceedToDeclineConsent" elevation="0" style="width:-webkit-fill-available;">
                  <oe-i18n-msg msgid="b_decline"></oe-i18n-msg>
              </paper-button>
            </div>
            <div class="mdl-cell--3-col">
                <paper-button id="proceed" raised class="primary-medium-button" on-tap="_proceedToPatchConsent" style = "width:-webkit-fill-available;">
                    <oe-i18n-msg msgid="b_Proceed"></oe-i18n-msg>
                </paper-button>
            </div>
          </div>
        </paper-card>
      </div>
    </div>
    `;
Polymer({
  is: 'open-banking-payment-consents-input',
  _template: template,
  behaviors: [corpBehaviours.appCommonBehaviour, corpBehaviours.appMenuBehaviour, corpSbBehaviour.corpAuthAndWorkflow],
  properties: {
    selectedPage: {
      type: String,
      value: 0,
      notify: true
    },
    openBankingDebitAccountsResponse: {
      type: Array,
      notify: true,
      value: []
    },
    openBankingConsentResponse: {
      type: Object,
      notify: true
    },
    userId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'userId');
      }
    },
    accountsListLoaded: {
      type: Boolean,
      value: false
    },
    displayRows: {
      type: Array,
      notify: true
    },
    consentId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'openBankingConsentId');
      }
    },
    filterVal: {
      type: String,
      value: ""
    },
    filterTransactions: {
      type: Array,
      notify: true,
      value: ['accountName', 'accountId', 'accountType.codeDescription']
    },
    selectedAccountList: {
      type: Array,
      value: [],
      notify: true
    },
    accountPermissionList: {
      type: Array,
      value: []
    },
    responseObject: {
      type: Object,
      notify: true
    },
    body: {
      type: Object,
      notify: true
    },
    actionType: {
      type: String,
      notify: true
    },
    selectedDebitAccount: {
      type: Object,
      notify: true,
      observer: '_selectedDebAcc'
    },
    infoMsgVatAmount: {
      type: String,
      value: getLabel('l_OpenBankingVATDisclaimer'),
      notify: true
    },
    infoMsgExchangeRate: {
      type: String,
      value: getLabel('l_OpenBankingexchangeRateDisclaimer'),
      notify: true
    }
  },
  ready() {
    this.fire('stop-processing-loader');
    this.$.fetchOpenBankingDebitAccounts.generateRequest();
    this.$.fetchOpenBankingConsents.generateRequest();
  },
  _openBankingDebitConsentResponse(event) {
    this.openBankingDebitAccountsResponse = event.detail.response;
  },
  _openBankingConsentsResponse(event) {
    this.accountsListLoaded = true;
    this.openBankingConsentResponse = event.detail.response;
  },
  _openBankingDebitConsentError(event) {
    showAjaxError(event);
    var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
    var headers = convertedArr.reduce(function (each, current, i) {
      var parts = current.split(': ');
      each[parts[0]] = parts.slice(1).join();
      return each;
    }, {});
    if (headers.channelcontext) {
      var messageToDisplay = "";
      var channelcontext = JSON.parse(headers.channelcontext);
      var msgList = [];
      if (channelcontext.status.message && channelcontext.status.message.length > 1) {
        for (i = 0; i < channelcontext.status.message.length; i++) {
          msgList.push(channelcontext.status.message[i].messageDesc);
        }
        messageToDisplay = msgList[0];
      }
      else if (channelcontext.status.message) {
        messageToDisplay = channelcontext.status.message[0].messageDesc;
      }
    }
    setTimeout(() => {
      if (clientStorage.get(storageType.session, 'backendRedirectUri')) {
        var redirectUrl = clientStorage.get(storageType.session, 'backendRedirectUri') + "?status=FAL" + "&state=" + clientStorage.get(storageType.session, 'openBankingState') + "&event=" + messageToDisplay;
        window.location.href = redirectUrl;
      }
    }, 5000);
  },
  _openBankingConsentsResponseError(event) {
    this.accountsListLoaded = true;
    showAjaxError(event);
    var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
    var headers = convertedArr.reduce(function (each, current, i) {
      var parts = current.split(': ');
      each[parts[0]] = parts.slice(1).join();
      return each;
    }, {});
    if (headers.channelcontext) {
      var messageToDisplay = "";
      var channelcontext = JSON.parse(headers.channelcontext);
      var msgList = [];
      if (channelcontext.status.message && channelcontext.status.message.length > 1) {
        for (i = 0; i < channelcontext.status.message.length; i++) {
          msgList.push(channelcontext.status.message[i].messageDesc);
        }
        messageToDisplay = msgList[0];
      }
      else if (channelcontext.status.message) {
        messageToDisplay = channelcontext.status.message[0].messageDesc;
      }
    }
    setTimeout(() => {
      if (clientStorage.get(storageType.session, 'backendRedirectUri')) {
        var redirectUrl = clientStorage.get(storageType.session, 'backendRedirectUri') + "?status=FAL" + "&state=" + clientStorage.get(storageType.session, 'openBankingState') + "&event=" + messageToDisplay;
        window.location.href = redirectUrl;
      }
    }, 5000);
  },
  _proceedToPatchConsent() {
    this.actionType = "APPROVE";
    if (_.isEmpty(this.selectedDebitAccount)) {
      this.fire('oe-show-error', getLabel("l_TxnDebitAccountErrorMsg"));
      return;
    }
    var url = "/api/CBUsers/" + this.userId + "/customopenbanking-consent-request";
    var method = "POST";
    var transactionType = "OPC";
    this.body = this.getRequestBody("APPROVE");
    this.submitNonFinancialDetails(url, method, this.body, "", transactionType, "");
  },
  _proceedToDeclineConsent() {
    this.actionType = "DECLINE";
    var url = "/api/CBUsers/" + this.userId + "/customopenbanking-consent-request";
    var method = "POST";
    var transactionType = "OPC";
    this.body = this.getRequestBody("DECLINE");
    this.submitNonFinancialDetails(url, method, this.body, "", transactionType, "");
  },
  getRequestBody(actionType) {
    var body = {
      "consentId": this.openBankingConsentResponse.consentId,
      "sessionId": clientStorage.get(storageType.session, 'openBankingSessionId'),
      "consentScope": clientStorage.get(storageType.session, 'openBankingScope'),
      "consentStatus": actionType,
      "consentCreationDateTime": moment.utc(this.openBankingConsentResponse.consentCreationDateTime).format("YYYY-MM-DDT00:00:00"),
      "executionDateTime": moment.utc(this.openBankingConsentResponse.executionDate).format("YYYY-MM-DDT00:00:00"),
      "statusUpdateDateTime": moment.utc(this.openBankingConsentResponse.statusUpdateDateTime).format("YYYY-MM-DDT00:00:00"),
      "corporateUser": this.openBankingConsentResponse.corporateUser,
      "updatedAt": moment.utc(this.openBankingConsentResponse.updatedAt).format("YYYY-MM-DDT00:00:00"),
      "transactionFromDate": moment.utc(this.openBankingConsentResponse.transactionFromDate).format("YYYY-MM-DDT00:00:00"),
      "transactionToDate": moment.utc(this.openBankingConsentResponse.transactionToDate).format("YYYY-MM-DDT00:00:00"),
      "consentLink": this.openBankingConsentResponse.consentLink,
      "accountIdList": this.selectedAccountList,
      "accountConsent": {},
      "paymentConsent": {
        "readRefundAccount": this.openBankingConsentResponse.paymentConsent.readRefundAccount,
        "localInstrument": this.openBankingConsentResponse.paymentConsent.localInstrument,
        "endToEndIdentification": this.openBankingConsentResponse.paymentConsent.endToEndIdentification,
        "instructedAmount": this.openBankingConsentResponse.paymentConsent.instructedAmount.amount,
        "instructedCurrecny": this.openBankingConsentResponse.paymentConsent.instructedCurrecny,
        "schemeName": this.openBankingConsentResponse.paymentConsent.schemeName,
        "creditorAccountId": this.openBankingConsentResponse.paymentConsent.creditorAccountId,
        "name": this.openBankingConsentResponse.paymentConsent.name,
        "reference": this.openBankingConsentResponse.paymentConsent.reference,
        "unstructuredReference": this.openBankingConsentResponse.paymentConsent.unstructuredReference,
        "paymentType": this.openBankingConsentResponse.paymentConsent.paymentType.cmCode,
        "swiftCode": this.openBankingConsentResponse.paymentConsent.swiftCode,
        "isIBAN": this.openBankingConsentResponse.paymentConsent.isIBAN,
        "bankCountryCode": this.openBankingConsentResponse.paymentConsent.bankCountryCode ? this.openBankingConsentResponse.paymentConsent.bankCountryCode.cmCode : "",
        "purposeCode": this.openBankingConsentResponse.paymentConsent.purposeCode ? this.openBankingConsentResponse.paymentConsent.purposeCode.cmCode : ""
      },
      "tppDetails": {
        "clientId": this.openBankingConsentResponse.tppDetails.clientId,
        "clientOrgId": this.openBankingConsentResponse.tppDetails.clientOrgId,
        "statementId": this.openBankingConsentResponse.tppDetails.statementId,
        "tppName": this.openBankingConsentResponse.tppDetails.tppName
      }
    }
    return body;
  },
  _callWorkflowPage(event) {
    var tempObj = event.detail.request.__data.response.error.message;
    this.responseObject = tempObj;
    this.selectedPage = 1;
  },
  _selectedDebAcc: function () {
    if (!_.isEmpty(this.selectedDebitAccount)) {
      var self = this;
      this.selectedAccountList = [this.selectedDebitAccount.accountId]
      this.dataUrl = "/api/CBUsers/" + this.userId + "/customoperativeaccounts/" + this.selectedDebitAccount.accountId;
      var ajaxCall = document.createElement('oe-ajax');
      ajaxCall.contentType = "application/json";
      ajaxCall.handleAs = "json";
      ajaxCall.url = this.dataUrl;
      ajaxCall.method = 'get';
      ajaxCall.addEventListener('response', function (event) {
        self.fire('stop-processing-loader');
        self.balanceResp = event.detail.response;
      });
      ajaxCall.addEventListener('error', function (event) {
        self.fire('stop-processing-loader');
        self.balanceResp = undefined;
      });
      ajaxCall.generateRequest();
      this.fire('start-processing-loader');
    }
  },
  _errorHandler(event) {
    showAjaxError(event);
    var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
    var headers = convertedArr.reduce(function (each, current, i) {
      var parts = current.split(': ');
      each[parts[0]] = parts.slice(1).join();
      return each;
    }, {});
    if (headers.channelcontext) {
      var messageToDisplay = "";
      var channelcontext = JSON.parse(headers.channelcontext);
      var msgList = [];
      if (channelcontext.status.message && channelcontext.status.message.length > 1) {
        for (i = 0; i < channelcontext.status.message.length; i++) {
          msgList.push(channelcontext.status.message[i].messageDesc);
        }
        messageToDisplay = msgList[0];
      }
      else if (channelcontext.status.message) {
        messageToDisplay = channelcontext.status.message[0].messageDesc;
      }
    }
    setTimeout(() => {
      if (clientStorage.get(storageType.session, 'backendRedirectUri')) {
        var redirectUrl = clientStorage.get(storageType.session, 'backendRedirectUri') + "?status=FAL" + "&state=" + clientStorage.get(storageType.session, 'openBankingState') + "&event=" + messageToDisplay;
        window.location.href = redirectUrl;
      }
    }, 5000);
  }
});
